<template>
  <div class="zs">
    <navCom :navActive="navActive"></navCom>

    <div class="user-main-right">
      <div style="padding: 5%">
        <div class="imgBox">
          <img :src="src">
        </div>
        <a :href="picture">
          <span class="xzzs">下载证书</span>
        </a>
      </div>
    </div>
    <footerCom></footerCom>

  </div>

</template>

<script>
  import navCom from '../components/welcome-nav';
  import footerCom from '../components/foot';
  import tool from '../assets/js/tool';
  export default {
    name: 'zs',
    data () {
      return {
        navActive: 6,
        src: '',
        picture: ''
      }
    },
    methods: {
      getTerms () {
        let data = {
          user_id: this.$store.state.uuid
        };
        tool.postData('Center_User/getCert', data, (res) => {
          console.log(res)
          this.src = res.data.data.picture;
          this.picture = res.data.data.download;
          // this.getLink()
        })
      },
      // getLink(){
      // let data={
      //   picture:this.src
      // };
      // tool.postData('Center_User/tcpdf ',data,(res)=>{
      //     // this.src = res.data.data.picture
      // })
      // tool.getData('Center_User/tcpdf',data,res=>{
      //
      // })

      // },
    },
    mounted () {
      this.getTerms()
    },
    components: {
      navCom,
      footerCom
    }
  }
</script>

<style >

  .imgBox{
    width: 800px;
    margin: 0 auto;
  }
  .imgBox img{
    width: 100%;
    height: auto;
  }
  .user-main-right{
    width: 1200px;
    height: auto;
    background: #ffffff;
    padding-bottom: 30px;
    margin:  30px auto;
  }
  .xzzs{
    font-size:16px;
    display: block;
    width: 110px;
    height: 55px;
    background: #1970ff;
    color: #fff;
    text-align: center;
    line-height: 55px;
    margin: 20px   auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/zs.vue